import {
    type FC
} from "react";
import type ICollapsibleContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    CollapsiblePartContentProps
} from "../../type";
import {
    withCollapsibleContext
} from "../../context";
import CollapseRegion from "../../internal/collapseRegion";

const CollapsibleContentContent: FC<CollapsiblePartContentProps<ICollapsibleContentProps>> = ({
    customTheme: customThemeProp,
    contentContainerStyle,
    isKeepMounted = false,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        content: contentDynamicStyle
    } = useStyles({
        placement: context.placement,
        spaces
    });

    return <CollapseRegion
        {...props}
        isKeepMounted={isKeepMounted}
        contentStyle={[
            contentContainerStyle,
            stylesheet.content,
            contentDynamicStyle
        ]}
        customTheme={customTheme}
        style={[
            style,
            stylesheet.container
        ]}
        isOpen={context.isOpen}
        id={context.contentID}
    >
        {children}
    </CollapseRegion>;
};
export default withCollapsibleContext("content", CollapsibleContentContent);
